export const publicConnectedAccountServices = [
  {
    id: 'iracing',
    nicename: 'iRacing',
    getProfileUrl: (accountId) =>
      `https://members.iracing.com/membersite/member/CareerStats.do?custid=${encodeURIComponent(accountId)}`,
  },
  {
    id: 'steam',
    nicename: 'Steam',
    getProfileUrl: (accountId) =>
      `https://steamcommunity.com/profiles/${encodeURIComponent(accountId)}`,
  },
  {
    id: 'ubisoft',
    nicename: 'Ubisoft',
    getProfileUrl: (accountId) =>
      `https://www.trackmania.com/players/${encodeURIComponent(accountId)}`,
  },
]

export const publicConnectedAccountServiceIds =
  publicConnectedAccountServices.map((service) => service.id)

export function getPublicConnectedAccountService(serviceId) {
  return publicConnectedAccountServices.find(
    (service) => service.id === serviceId,
  )
}

export function getPublicConnectedAccountProfileUrl(account) {
  const service = getPublicConnectedAccountService(account?.serviceId)

  if (!service || !account?.serviceAccountId) return null

  return service.getProfileUrl(String(account.serviceAccountId))
}
